import { render, staticRenderFns } from "./search-box.vue?vue&type=template&id=231e0365&scoped=true&"
import script from "./search-box.vue?vue&type=script&lang=js&"
export * from "./search-box.vue?vue&type=script&lang=js&"
import style0 from "./search-box.vue?vue&type=style&index=0&id=231e0365&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231e0365",
  null
  
)

export default component.exports